<div>
    <h1 mat-dialog-title>
        Resolve Document Issue
        <p>Deal #{{ data.dealId }} - {{ data.docId }} {{ data.docDisplayName }}</p>
        <p></p>
    </h1>

    <div class="settings-group">
        <div class="section-wrapper">
            <profile-section title="Change Document Status">
                <div class="align-home">
                    <mat-form-field>
                        <mat-label>Select Document Status</mat-label>
                        <mat-select [(value)]="selectedCurrentStatus" placeholder="Select Your Document Status">
                            <mat-option [value]="status" *ngFor="let status of documentStatuses">{{ status }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div class="align-btn">
                        <button mat-button class="primary" (click)="helpDocumentsSumbitStatus(selectedCurrentStatus)">Save Status Change</button>
                    </div>
                </div>
            </profile-section>
        </div>
        <div class="section-wrapper">
            <profile-section title="Request Resign">
                <div class="align-home">
                    <div style="display: flex; align-items: center;">
                        <mat-slide-toggle [(ngModel)]="signatureImagesOnDocChecked" (change)="toggleSwitchPdfImageCheck($event)">Pdf Has Signatures On The Document?</mat-slide-toggle>
                        <span class="viewPdf" (click)="showPdfViewModal()">View Document</span>
                    </div>
                    <mat-slide-toggle [(ngModel)]="overrideIsCertifiedChecked" (change)="toggleSwitchOverrideCertCheck($event)">Override Current Document Certificate With New?</mat-slide-toggle>
                    <p *ngIf="overrideIsCertifiedChecked" class="doc-warning">This can permanently damage the document and require a full document regeneration with signing. Only use this as a last resort to fix the document.</p>
                    <p class="doc-warning">
                        This will resend the document to get another certificate. Are you sure you want to resend the document to the queue?
                    </p>
                    <div class="align-btn">
                        <button mat-button class="primary" (click)="helpDocumentsFormSubmit()">Send Request</button>
                    </div>
                </div>
            </profile-section>
        </div>
    </div>
    <div class="form-footer">
        <section>
            <div class="cancel-button-row">
                <div class="confirm-actions right-align" mat-dialog-actions>
                    <button mat-button class="secondary" type="button" (click)="cancel()">Close</button>
                </div>
            </div>
        </section>
    </div>
    <create-deal-spinner *ngIf="isLoading"></create-deal-spinner>
</div>
